var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "25.25px",
  height: "25.25px",
  viewBox: "0 0 20 20",
  version: 1.1,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Warning icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Schmodel-new-landing-page",
  transform: "translate(-551.000000, -5688.000000)",
  stroke: "#E4293A",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("g", {
  id: "Warning-icon",
  transform: "translate(552.000000, 5689.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5,14.125 C9.29289322,14.125 9.125,14.2928932 9.125,14.5 C9.125,14.7071068 9.29289322,14.875 9.5,14.875 C9.70710678,14.875 9.875,14.7071068 9.875,14.5 C9.875,14.2928932 9.70710678,14.125 9.5,14.125 L9.5,14.125",
  id: "Path",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.5,
  y1: 12,
  x2: 9.5,
  y2: 6,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2967987,0.80781811 C10.0539032,0.313319973 9.55092739,0 9,0 C8.44907261,0 7.94609684,0.313319973 7.7032013,0.80781811 L0.124808919,16.2463812 C-0.060651712,16.6236611 -0.0382298672,17.0699497 0.184111002,17.426741 C0.40645187,17.7835322 0.797212267,18.0002787 1.21760782,18 L16.7823922,18 C17.2027877,18.0002787 17.5935481,17.7835322 17.815889,17.426741 C18.0382299,17.0699497 18.0606517,16.6236611 17.8751911,16.2463812 L10.2967987,0.80781811 Z",
  id: "Path",
  strokeLinejoin: "round"
}))))));
export default __webpack_public_path__ + "static/media/warning.083dc3bd.svg";
export { SvgComponent as ReactComponent };